<template>
    <div>
        <b-button variant="danger" @click="downloadPdf">
            <i class="fas fa-download"></i> Baixar PDF
        </b-button>

        <VueHtml2pdf
            class="d-none"
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="true"
            :filename="`tarefa_${task.protocol || task._id}`"
            :pdf-quality="2"
            :manual-pagination="true"
            pdf-format="a4"
            pdf-orientation="portrait"
            ref="html2Pdf"
        >
            <section slot="pdf-content">
                <div style="padding: 20px; font-family: Arial, sans-serif;">
                    <h1 style="color: #2e8b8b; border-bottom: 2px solid #2e8b8b; padding-bottom: 10px;">
                        Tarefa: {{ task.reason || task.protocol }}
                    </h1>

                    <div style="background: #f8f9fa; padding: 15px; border-radius: 6px; margin-bottom: 20px;">
                        <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px;">
                            <div v-if="task.protocol">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Código da Tarefa:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ task.protocol }}</div>
                            </div>

                            <div v-if="task.ref_protocol">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Protocolo do Atendimento:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ task.ref_protocol }}</div>
                            </div>

                            <div v-if="task.service_date">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Data do Malote:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ formatDate(task.service_date) }}</div>
                            </div>

                            <div v-if="task.service_type">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Tipo de Serviço:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ task.service_type }}</div>
                            </div>

                            <div v-if="task.channel">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Canal:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ formatChannel(task.channel) }}</div>
                            </div>

                            <div v-if="task.client_name">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Nome do Cliente:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ task.client_name }}</div>
                            </div>

                            <div v-if="task.address">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Endereço:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ task.address }}</div>
                            </div>

                            <div v-if="task.reason">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Motivo de Acionamento:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">
                                    {{ task.reason }}{{ task.is_itau ? ' (Itaú)' : '' }}
                                </div>
                            </div>

                            <div v-if="task.janela">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Janela:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ task.janela }}</div>
                            </div>

                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Base (Grupo):</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ task.owner_group ? task.owner_group.name : "" }}</div>
                            </div>

                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Responsável:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ task.owner_user ? task.owner_user.name : "" }}</div>
                            </div>

                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Status:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ task.status ? task.status.name : "" }}</div>
                            </div>

                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Prioridade:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ task.priority ? task.priority.name : "" }}</div>
                            </div>

                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Cliente Itaú:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ task.is_itau ? 'Sim' : 'Não' }}</div>
                            </div>

                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Criado em:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ formatDate(task.createdAt) }}</div>
                            </div>

                            <div>
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Atualizado em:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ formatDate(task.updatedAt) }}</div>
                            </div>

                            <div v-if="task.closed_at">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Concluído em:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ formatDate(task.closed_at) }}</div>
                            </div>

                            <div v-if="task.closed_by">
                                <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Concluído por:</div>
                                <div style="font-size: 12px; color: #333; font-weight: 500;">{{ task.closed_by.name || task.closed_by }}</div>
                            </div>
                        </div>

                        <div v-if="task.description" style="margin-top: 15px;">
                            <div style="font-size: 10px; color: #666; font-weight: bold; text-transform: uppercase;">Descrição:</div>
                            <div style="font-size: 12px; color: #333; font-weight: 500; margin-top: 5px; white-space: pre-wrap;">{{ task.description }}</div>
                        </div>
                    </div>

                    <div
                        style="background: white; border: 1px solid #ddd; border-radius: 6px; padding: 15px; margin-bottom: 20px;"
                        v-if="task.comments && task.comments.length"
                    >
                        <h4 style="margin-bottom: 15px; color: #333;">Comentários</h4>
                        <div v-for="comment in task.comments" :key="comment._id"
                            style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 1px solid #eee;">
                            <div style="font-weight: bold; font-size: 12px; margin-bottom: 2px;">
                                {{ comment.created_by ? comment.created_by.name : "" }}
                            </div>
                            <div style="font-size: 10px; color: #666; margin-bottom: 5px;">{{ formatDate(comment.createdAt) }}</div>
                            <div style="font-size: 11px; color: #333; line-height: 1.4;">{{ comment.text }}</div>
                        </div>
                    </div>

                    <div
                        style="background: white; border: 1px solid #ddd; border-radius: 6px; padding: 15px;"
                        v-if="task.timeline && task.timeline.length"
                    >
                        <h4 style="margin-bottom: 15px; color: #333;">Linha do Tempo</h4>
                        <div v-for="event in task.timeline" :key="event._id"
                            style="margin-bottom: 15px; padding-bottom: 15px; border-bottom: 1px solid #eee;">
                            <div style="font-weight: bold; font-size: 12px; margin-bottom: 2px;">{{ event.event }}</div>
                            <div style="font-size: 10px; color: #666; margin-bottom: 5px;">{{ formatDate(event.createdAt) }}</div>
                            <div style="font-size: 11px; color: #333; line-height: 1.4;">{{ event.detail }}</div>
                        </div>
                    </div>
                </div>
            </section>
        </VueHtml2pdf>
    </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf';
import { formatDate } from '../../helpers/utils';

export default {
    name: "TaskPDF",
    components: { VueHtml2pdf },
    props: {
        task: {
            type: Object,
            default: () => ({})
        },
    },
    methods: {
        formatDate,
        downloadPdf() {
            this.$refs.html2Pdf.generatePdf();
        },
        formatChannel(channel) {
            if (channel === 'whatsapp') return 'Whatsapp';
            if (channel === 'telefone') return 'Telefone';
            if (channel === 'phone') return 'Telefone';
            if (channel === 'email') return 'E-mail';
            return channel;
        },
    },
}
</script>
